<template>
  <div 
    class="fixed inset-0 pointer-events-none overflow-hidden z-0"
  >
    <div 
      v-for="(orb, index) in orbs"
      :key="index"
      class="absolute rounded-full blur-3xl opacity-30 animate-float"
      :style="{
        width: orb.size + 'px',
        height: orb.size + 'px',
        left: orb.x + '%',
        top: orb.y + '%',
        background: orb.color,
        animationDelay: orb.delay
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AnimatedBackground',
  data() {
    return {
      orbs: [
        { x: 15, y: 20, size: 300, color: 'rgba(16,185,129,0.4)', delay: '0s' },
        { x: 85, y: 10, size: 250, color: 'rgba(59,130,246,0.3)', delay: '-5s' },
        { x: 40, y: 80, size: 280, color: 'rgba(236,72,153,0.35)', delay: '-10s' },
        { x: 70, y: 60, size: 200, color: 'rgba(251,191,36,0.3)', delay: '-15s' }
      ]
    }
  }
}
</script>

<style scoped>
@keyframes float {
  0%, 100% {
    transform: translateY(0px) translateX(0px);
  }
  33% {
    transform: translateY(-20px) translateX(10px);
  }
  66% {
    transform: translateY(10px) translateX(-10px);
  }
}

.animate-float {
  animation: float 20s ease-in-out infinite;
}
</style>
